import { ArrowLeftIcon } from "@heroicons/react/outline";
import { getTranslation } from "dictionary";
import { useUserContext } from "context/UserContext";
import { useMenuContext } from "context/MenuContext";

interface Props {
  onDismiss: () => void;
}
const OrderNavBar: React.FC<Props> = ({ onDismiss }) => {
  const { language } = useUserContext();
  const { description, business_name, navbarDesign } = useMenuContext();

  const backgroundColor = navbarDesign.backgroundColor;
  const textColor = navbarDesign.textColor;

  return (
    <div
      className="p-4 text-lg grid grid-cols-navBar sticky top-0 z-40 tracking-wider items-center "
      style={{ backgroundColor, color: textColor }}
    >
      <ArrowLeftIcon className="h-6 w-6" onClick={onDismiss} />
      <div>
        <div className="uppercase font-medium text-center">
          {getTranslation("menu_order", "ORDER", language)}
        </div>
        {description ? (
          <div className="hidden md:block text-center text-sm">
            {business_name}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default OrderNavBar;
